"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopover: function() {
        return _index.TeachingPopover;
    },
    renderTeachingPopover_unstable: function() {
        return _index.renderTeachingPopover_unstable;
    },
    useTeachingPopover_unstable: function() {
        return _index.useTeachingPopover_unstable;
    }
});
const _index = require("./components/TeachingPopover/index");
